<div class="mt-md-2 pt-md-5">
  <h2 class="side-headings">Renting, the way it's supposed to be</h2>
  <div class="container medium-container mt-4">
    <div class="text-center">
      <p class="subhead-2">Find and rent the equipment you need, we’ll handle everything else.</p>
    </div>
    <div class="row text-center text-md-left">
      <ng-container *ngFor="let rentingInfoCard of rentingInfoCards">
        <div class="col-md-4">
          <common-marketing-card [marketingCard]="rentingInfoCard"></common-marketing-card>
        </div>
      </ng-container>
    </div>
  </div>
</div>
